import React from 'react';
import TokenChips, { appendToken } from './TokenChips';
import ShortLinkField from './ShortLinkField';
import Input from '../ui/Input';
import Textarea from '../ui/Textarea';
import SmsPreview from '../campaigns/SmsPreview';
import styles from './MessagingFields.module.css';

class SmsFields extends React.Component {
  render() {
    const { text = '', templateId = '', attributionLinkId = '', onChange, showPreview = true } = this.props;
    return (
      <div className={showPreview ? styles.msgLayout : undefined}>
        <div className={styles.msgFields}>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>Message <span className={styles.req}>*</span></label>
            <Textarea maxLength={160} rows={3} resize={false} value={text} onChange={e => onChange('text', e.target.value)} />
            <div className={styles.fiHint}>Must match your registered DLT template's approved wording exactly.</div>
            <TokenChips onInsert={token => onChange('text', appendToken(text, token))} />
            <ShortLinkField
              attributionLinkId={attributionLinkId}
              onTag={link => onChange('attributionLinkId', link.id)}
              onUntag={() => onChange('attributionLinkId', '')}
            />
          </div>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>DLT template ID <span className={styles.opt}>(optional)</span></label>
            <Input value={templateId} onChange={e => onChange('templateId', e.target.value)} />
          </div>
        </div>
        {showPreview && <SmsPreview text={text} templateId={templateId} />}
      </div>
    );
  }
}

export default SmsFields;
